import { inwardCashReceiptAddApi } from "../../api/inwardCashReceipt/inwardCashReceiptAddApi"

type PayloadShape = Parameters<typeof inwardCashReceiptAddApi>[0]

export async function inwardCashReceiptAddService(payload: PayloadShape, token: string) {
	return await inwardCashReceiptAddApi(payload, token)
}
